import { ExternalLink, MapPin } from "lucide-react";

const ADD_BUSINESS_URL =
  "https://support.google.com/business/answer/2911778?co=GENIE.Platform%3DDesktop&hl=en";

interface GoogleMapsHintProps {
  /** "compact" sits tight under a form field; "banner" gets its own row on landing pages. */
  variant?: "compact" | "banner";
  className?: string;
}

/**
 * Static pre-flight hint explaining the "must be on Google Maps" prerequisite
 * and linking to Google's "Add your business" flow for restaurants that aren't
 * listed yet. Rendered on /new and the landing hero so users learn the
 * constraint before they submit.
 */
export function GoogleMapsHint({
  variant = "compact",
  className = "",
}: GoogleMapsHintProps) {
  if (variant === "banner") {
    return (
      <div
        className={`rounded-[var(--radius-lg)] border border-[var(--color-border-subtle)] bg-[var(--color-bg-muted)] px-[var(--space-4)] py-[var(--space-3)] text-[length:var(--font-size-sm)] text-[var(--color-text-secondary)] ${className}`}
      >
        <div className="flex items-start gap-[var(--space-3)]">
          <MapPin className="size-4 shrink-0 mt-[var(--space-0-5)] text-[var(--color-primary)]" aria-hidden="true" />
          <p>
            <span className="font-[number:var(--font-weight-semibold)] text-[var(--color-text-primary)]">
              Your restaurant must be on Google Maps.
            </span>{" "}
            Not listed yet?{" "}
            <a
              href={ADD_BUSINESS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-[var(--space-1)] text-[var(--color-primary)] hover:underline"
            >
              Add your business <ExternalLink className="size-3" aria-hidden="true" />
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return (
    <p
      className={`text-[length:var(--font-size-xs)] text-[var(--color-text-muted)] ${className}`}
    >
      Your restaurant must be on Google Maps.{" "}
      <a
        href={ADD_BUSINESS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-[var(--space-1)] text-[var(--color-primary)] hover:underline"
      >
        Add your business <ExternalLink className="size-3" aria-hidden="true" />
      </a>{" "}
      if it isn't listed yet.
    </p>
  );
}
